const baseOrigin = "https://develop.qubiankeji.com:28082";
export {
    baseOrigin
}
